import brandConfig from 'brandConfig'
import { ALLCOLIBRI_IMPACT_REPORT_URL } from '../constants/app'
import { NAVIGATION_TARGET_BLANK } from '../constants/externalUrls'
import { REDIRECT_URL } from '../constants/navigation'
import {
  buildBinanceShopUrl,
  buildCoinbaseShopUrl,
  isBrandIdBinance
} from './pointsExchange.helpers'
import { snakeCaseToDashCase } from './string.helpers'
import { COE_SSO_SESSION_PATH } from '../constants/api'

const buildViewShopUrl = (provider) => {
  if (provider.isCrypto) {
    return isBrandIdBinance(provider.brandId)
      ? buildBinanceShopUrl(provider.symbol)
      : buildCoinbaseShopUrl(provider.name)
  }
  return (
    provider?.metadata?.links?.websiteUrl ||
    provider?.redemptionCatalogueUrl ||
    provider?.loyaltyProgramUrl ||
    provider?.websiteUrl
  )
}

const buildCOEUrl = (brandId) => {
  return COE_SSO_SESSION_PATH + (brandId ? `/demo/${brandId}` : '')
}

// @TODO: Implement for impact report using allcolibri
const getImpactReportUrl = () => {
  const baseUrl = ALLCOLIBRI_IMPACT_REPORT_URL
  if (brandConfig.features.enableRootImpactReport) {
    return baseUrl
  }
  return `${baseUrl}-${snakeCaseToDashCase(brandConfig.brandId)}`
}

const NAVIGATION_BLANK_PARAMS = {
  target: NAVIGATION_TARGET_BLANK,
  rel: 'noopener noreferrer'
}

const prependHttpsIfNotExists = (link) => {
  return link && link.indexOf('://') === -1 ? `https://${link}` : link
}

const isRedirectScreen = ({ pathname }) => {
  const splitPathname = pathname.split('/')
  return splitPathname[2] === REDIRECT_URL || false
}

export {
  buildViewShopUrl,
  buildCOEUrl,
  getImpactReportUrl,
  isRedirectScreen,
  NAVIGATION_BLANK_PARAMS,
  prependHttpsIfNotExists
}
